"use client";
import { useContext } from "react";
import { BrowseContext } from "./ContextProvider.js";
const useBrowseContext = () => {
  const context = useContext(BrowseContext);
  if (!context) {
    throw new Error(
      "`useBrowseContext` must be used within a `BrowseContextProvider`"
    );
  }
  return context;
};
export {
  useBrowseContext
};
